import { useState } from "react";
import { Button } from "..";
import "./AuthForm.scss";
import { CaptchaWidget } from "../CaptchaWidget/CaptchaWidget";

function ForgotPasswordForm({
  onSubmit,
  onBackToLogin,
  errorMessage,
  forgotting,
  setForgetting,
  setCaptchaToken,
  ref
}) {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setForgetting?.(true);
    onSubmit?.({ email });
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <p style={{ margin: 0, color: "#5C4F48", fontSize: "0.875rem" }}>
        Zadajte emailovú adresu spojenú s vaším účtom a pošleme vám nové heslo
        do schránky.
      </p>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="forgot-email">
          Email
        </label>
        <input
          id="forgot-email"
          name="email"
          type="email"
          className="auth-form__input"
          placeholder="vas@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          required
        />
      </div>
      <CaptchaWidget ref={ref} onVerify={(token) => setCaptchaToken(token)} />
      {errorMessage && <p className="auth-form__error">{errorMessage}</p>}

      <div className="auth-form__submit">
        <Button
          variant="primary"
          type="submit"
          style={{ width: "100%" }}
          disabled={forgotting}
        >
          {forgotting ? "Odosiela sa..." : "Odoslať nové heslo"}
        </Button>
      </div>

      {onBackToLogin && (
        <p className="auth-form__switch">
          Spomínate si na heslo?{" "}
          <button
            type="button"
            className="auth-form__link"
            onClick={onBackToLogin}
          >
            Prihlásiť sa
          </button>
        </p>
      )}
    </form>
  );
}

export default ForgotPasswordForm;
